import type { Namespace } from '../types';

// DE drafted — queued for native review in the task file's "DE review queue".
export const recover = {
  title: { de: 'Passwort vergessen?', en: 'Forgot your password?' },
  lead: {
    de: 'Geben Sie Ihre E-Mail ein — wir senden Ihnen einen Einmalcode zum Zurücksetzen.',
    en: "Enter your email and we'll send you a one-time code to reset it.",
  },
  emailPlaceholder: { de: 'sie@firma.com', en: 'you@company.com' },
  sendError: {
    de: 'Der Code konnte nicht gesendet werden. Bitte erneut versuchen.',
    en: 'Could not send the code. Please try again.',
  },
  sending: { de: 'Wird gesendet…', en: 'Sending…' },
  sendCode: { de: 'Reset-Code senden', en: 'Send reset code' },

  codeTitle: { de: 'Code eingeben', en: 'Enter your code' },
  sentPrefix: { de: 'Wir haben einen Einmalcode an', en: 'We sent a one-time code to' },
  // Leading space in DE is intentional: rendered as `{prefix} {email}{suffix}`.
  sentSuffix: { de: ' gesendet. Er läuft in 15 Minuten ab.', en: '. It expires in 15 minutes.' },
  otp: { de: 'Einmalcode', en: 'One-time code' },
  newPassword: { de: 'Neues Passwort', en: 'New password' },
  confirmPassword: { de: 'Neues Passwort bestätigen', en: 'Confirm new password' },
  resetError: {
    de: 'Passwort konnte nicht zurückgesetzt werden. Prüfen Sie den Code und versuchen Sie es erneut.',
    en: 'Could not reset your password. Check the code and try again.',
  },
  resetting: { de: 'Wird zurückgesetzt…', en: 'Resetting…' },
  resetPassword: { de: 'Passwort zurücksetzen', en: 'Reset password' },

  doneTitle: { de: 'Passwort zurückgesetzt', en: 'Password reset' },
  doneText: {
    de: 'Ihr Passwort wurde aktualisiert. Sie können sich jetzt mit dem neuen Passwort anmelden.',
    en: 'Your password has been updated. You can now sign in with your new password.',
  },
  backToLogin: { de: 'Zurück zur Anmeldung', en: 'Back to login' },
} as const satisfies Namespace;
